<template>
  <div :style="'background: ' + store.theming.background + '; color: ' + store.theming.color" class="p-4">
    <CContainer>
      <CRow class="justify-content-center mb-3">
        <CCol :md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <p :style="'color: black;'"><b>{{ $t('login.loginText') }}</b></p>
                  <CInputGroup class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user" />
                    </CInputGroupText>
                    <CFormInput
                      :placeholder="$t('login.form.customerNumber')"
                      autocomplete="username"
                      v-model="cardNumber"
                    />
                  </CInputGroup>
                  <CInputGroup class="mb-4">
                    <CInputGroupText>
                      <CIcon icon="cil-lock-locked" />
                    </CInputGroupText>
                    <CFormInput
                      type="password"
                      :placeholder="$t('login.form.password')"
                      autocomplete="current-password"
                      v-model="password"
                    />
                  </CInputGroup>
                  <CRow>
                    <CCol :xs="12">
                      <CLoadingButton :loading="loading" :style="'background-color: ' + store.theming.headerBackground + '; color: ' + store.theming.headerColor + ';'" class="px-4" @click="login">
                        {{ $t('login.form.loginButton') }}
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                  <CRow class="mt-4">
                    <CCol :xs="12" :style="'color: black;'">
                      {{ $t('login.form.gotBarcode') }}<br/><br/>
                      <CLoadingButton :loading="loading" :style="'background-color: ' + store.theming.headerBackground + '; color: ' + store.theming.headerColor + ';'" class="px-4" @click="loginWithBarcode">
                        {{ $t('login.form.loginWithBarcode') }}
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                  <!--
                  <CRow class="mt-4">
                    <CCol :xs="12" :style="'color: black;'">
                      Sie haben Ihr Passwort vergessen und möchten ein neues Passwort erhalten?<br/><br/>
                      <CLoadingButton :loading="loading" :style="'background-color: ' + store.theming.headerBackground + '; color: ' + store.theming.headerColor + ';'" class="px-4" @click="login">
                        Passwort vergessen
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                  -->
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
      <CRow class="justify-content-center">
        <CCol :md="8">
          <CCardGroup>
            <CCard class="text-white py-5" :style="'background-color: ' + store.theming.headerBackground + '; color: ' + store.theming.headerColor + ';'">
              <CCardBody class="text-center">
                <div>
                  <h2>{{ $t('login.registration.newCard') }}</h2>
                  <p>
                    {{ $t('login.registration.noCardYetText') }}
                  </p>
                  <CLoadingButton color="light" variant="outline" class="mt-3" @click="router.push('/registration')">
                    {{ $t('login.registration.registrationButton') }}
                  </CLoadingButton>
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>

import { ref } from 'vue';
import axios from 'axios';
import { useRouter } from "vue-router";
import {useCardDataStore} from "@/stores/cardData";
import {useToastStore} from "@/stores/toast";
import {useStore} from "vuex";
import { useI18n } from "vue-i18n";

export default {
  name: 'LoginComponent',
  setup() {

    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    const vuexStore = useStore();
    const store = useCardDataStore();
    const toastStore = useToastStore();

    let cardNumber = ref('');
    let password   = ref('');
    const loading  = ref(false);
    const toasts   = ref([]);
    const router   = useRouter();

    if( store.general.login ) {
      router.push('/customerCard');
    }

    function loginWithBarcode() {

      router.push('/barcodeLogin');
    }

    function login() {

      loading.value = true;
      cardNumber.value = cardNumber.value.toUpperCase();
      store.menuStates.sales = false;

      axios.post( localStorage.getItem('host') + '/api/login', {
        cardID: cardNumber.value,
        password: password.value,
      }).then(function (response) {

        loading.value = false;

        let result = response.data.data.GetReregisterAppResult.ReregisterInfo;

        if( result.Status === 'OK') {

          localStorage.setItem('cardID', cardNumber.value);
          localStorage.setItem('deviceID', result.deviceID);

          store.general.deviceID   = result.deviceID;
          store.general.cardID     = cardNumber.value;
          store.general.login      = true;

          store.fetchSalesPermissions();

          router.push('/customerCard');

        } else if ( result.Status === 'ERROR' ) {

          switch( result.ErrorCode ) {

            case 'NO_CARD_FOUND':

              toastStore.w(t('toast.cardNumberInvalid'));
              break;

            case 'WRONG_PASSWORD':

              toastStore.w(t('toast.wrongPassword'));
              break;

            default:
              toastStore.e(result.ErrorCode);
          }

        }

      }).catch(function (error) {
        console.log(error);
      });

    }

    vuexStore.commit('foldSidebarBack');

    return {
      store,
      router,
      toastStore,
      loading,
      toasts,
      cardNumber,
      password,
      loginWithBarcode,
      login,
    }
  }
}
</script>
